import { useState } from 'react';
import moment from 'moment';
import humanize from 'humanize';
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { useQuery } from 'react-query';
import { getPolicies } from 'src/services/policies.service';
import { Stack } from '@mui/material';
import { Button, CircularProgress } from '@material-ui/core';
import PolicyDialog from './PolicyDialog';
import PolicyRoundedIcon from '@material-ui/icons/PolicyRounded';
import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
const columns = [
  {
    field: 'name',
    headerName: 'Policy Name',
    width: 300,
    type: 'string'
  },
  {
    field: 'duration',
    headerName: 'Duration (Months)',
    width: 250,
    type: 'number'
  },
  {
    field: 'amount',
    headerName: 'Amount (EGP)',
    width: 200,
    type: 'number',
    valueFormatter: ({ value }) => {
      return value ? humanize.numberFormat(value) : 'NA';
    }
  },
  {
    field: 'specializations',
    headerName: 'Specializations',
    width: 300,
    type: 'string',
    valueFormatter: ({ value }) => {
      return value !== null ? value : 'NA';
    }
  },
  {
    field: 'max_requests',
    headerName: 'Max Requests',
    width: 200,
    type: 'number',
    valueFormatter: ({ value }) => {
      return value !== null ? value.toString() : 'NA';
    }
  },
  {
    field: 'start_date',
    headerName: 'Start Date',
    width: 200,
    type: 'date',
    valueFormatter: ({ value }) => {
      return value !== null ? moment(new Date(value)).format('DD MMM YYYY') : 'NA';
    }
  }
];
function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

const useStyles = makeStyles((theme) => ({
  expiredPolicy: {
    backgroundColor: theme.palette.warning.light,
    '&:hover': {
      backgroundColor: theme.palette.warning.lighter
    }
  }
}));

const PoliciesTable = () => {
  const classes = useStyles();
  const getRowClassName = (params) => {
    // return 'expired_policy';
    //color the row if the policy is expired (start_date + duration >= today)
    if (
      params.row.start_date !== null &&
      moment(new Date(params.row.start_date)).add(params.row.duration, 'months') < moment()
    ) {
      return classes.expiredPolicy;
    }

    return '';
  };
  const theme = useTheme();
  const [filterModel, setFilterModel] = useState({
    items: JSON.parse(localStorage.getItem('policiesFilterModel')) || []
  });
  const [pageSize, setPageSize] = useState(Number(localStorage.getItem('policiesPageSize')) || 10);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { isLoading, isError, data: policies, error } = useQuery('policies', getPolicies);
  const [dialogState, setDialogState] = useState('create');
  const [selectedPolicy, setSelectedPolicy] = useState(null);

  return (
    <div>
      <PolicyDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        policy={selectedPolicy}
        state={dialogState}
      />

      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-between"
        style={{ marginBottom: '1rem' }}
      >
        <Stack direction={'row'} alignItems="center" style={{}}>
          <PolicyRoundedIcon style={{ marginRight: '0.5rem', color: theme.palette.grey[700] }} />
          <h2 align="left">Policies</h2>
        </Stack>
        <Button
          color="incorta"
          variant="contained"
          onClick={() => {
            setDialogOpen(true);
            setDialogState('create');
          }}
          disabled={dialogOpen}
        >
          Add Policy
        </Button>
      </Stack>
      {isLoading ? (
        <CircularProgress color="incorta" />
      ) : isError ? (
        error.message
      ) : (
        <DataGrid
          rows={policies.data.map((policy) => {
            return {
              ...policy,
              specializations: policy.specializations
                .map((spec) => spec.specialization_description)
                .join(', ')
            };
          })}
          getRowClassName={getRowClassName}
          autoHeight
          columns={columns}
          filterModel={filterModel}
          onFilterModelChange={(model) => {
            localStorage.setItem('policiesFilterModel', JSON.stringify(''));
            setFilterModel({
              items: model.items
            });
          }}
          onRowClick={(e) => {
            setSelectedPolicy(e.row);
            setDialogState('edit');
            setDialogOpen(true);
          }}
          pageSize={pageSize}
          onPageSizeChange={(newSize) => {
            localStorage.setItem('policiesPageSize', newSize);
            setPageSize(newSize);
          }}
          rowsPerPageOptions={[5, 10, 15, 20]}
          components={{
            Toolbar: CustomToolbar
          }}
          disableSelectionOnClick
        />
      )}
    </div>
  );
};

export default PoliciesTable;
